module.exports = {
  "growthPaymentsPageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "hasCreateAccess": {
        "type": "boolean",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": [
          "pro",
          "none",
          "enterprise",
          "starter"
        ],
        "isOptional": true
      },
      "chargesEnabled": {
        "type": "boolean",
        "isOptional": true
      },
      "payoutsEnabled": {
        "type": "boolean",
        "isOptional": true
      },
      "referrerUrl": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "payments-home",
    "version": "1"
  },
  "hubSpotApplicationFormInteraction": {
    "name": "hubspot-application-form-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "focus",
        "blur",
        "click",
        "select"
      ],
      "field": {
        "type": "string"
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "referrerUrl": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "payments-home",
    "version": "1"
  },
  "paymentSettingsInteraction": {
    "name": "payment-settings-interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "goToPaymentsEnrollmentViewed",
          "goToPaymentsEnrollmentClicked",
          "setUpHubspotPaymentsViewed",
          "goToProcessorPickerViewed",
          "setUpHubspotPaymentsClicked",
          "goToProcessorPickerClicked",
          "viewPricingDetailsClicked",
          "goToZeroStateButtonClicked",
          "setUpStripePaymentsViewed",
          "setUpStripePaymentsClicked",
          "HSApplicationGoBackClicked",
          "HSApplicationNextStepClicked",
          "BYOSApplicationNextStepClicked",
          "BYOSJoinWaitlistClicked",
          "closeHSApplicationClicked",
          "closeProcessorPickerClicked",
          "closeBYOSApplicationClicked",
          "openFaq",
          "cancelModalGoBackButtonClicked",
          "cancelModalConfirmButtonClicked",
          "openCancelSurvey",
          "noPermissionsModalViewed",
          "submitCancelSurvey",
          "rejectCancelSurvey",
          "scrollOnEmptyState",
          "emptyStateLinkClick",
          "emptyStateButtonClick",
          "quoteScroll",
          "videoPlay",
          "clickBackToPaymentsOverviewButton",
          "stripeApplicationSuccessModalButtonClicked",
          "fullApplicationSubmitted",
          "stripeApplicationFallbackRedirectButtonClicked",
          "showFallbackModal",
          "stripeBusinessOwnerClickAdd",
          "stripeBusinessOwnerClickExisting",
          "stripeBusinessOwnerClickRemove",
          "stripeBusinessOwnerUpdate",
          "stripeBusinessOwnerEditCancelClicked",
          "stripeBusinessOwnerEditDeleteClicked",
          "applicationSubmitButtonClicked",
          "contactSidePanelButtonClicked",
          "contactSidePanelInputInteraction",
          "contactSidePanelSubmissionSuccess",
          "gotoGuideButtonClicked",
          "gotoUpgradeButtonClicked",
          "gotoZeroStateButtonClicked"
        ]
      },
      "productLevel": {
        "type": [
          "pro",
          "none",
          "enterprise",
          "starter"
        ],
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "page": {
        "type": "string",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "referrerUrl": {
        "type": "string",
        "isOptional": true
      },
      "section": {
        "type": "string",
        "isOptional": true
      },
      "index": {
        "type": "number",
        "isOptional": true
      },
      "fields": {
        "type": "array",
        "isOptional": true
      },
      "customFormFields": {
        "type": "array",
        "isOptional": true
      },
      "missingFeatures": {
        "type": "array",
        "isOptional": true
      }
    },
    "namespace": "payments-home",
    "version": "1"
  },
  "hubSpotApplicationSubmissionIneligibleMerchant": {
    "name": "hubspot-application-submission-ineligible-merchant",
    "class": "usage",
    "properties": {
      "merchantLegalEntityCountries": {
        "type": "array",
        "isOptional": true
      },
      "entityCountry": {
        "type": "string",
        "isOptional": true
      },
      "referrerUrl": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "payments-home",
    "version": "1"
  }
};